import React from 'react';

export const renderIf = (condition: boolean, jsx: (() => JSX.Element) | JSX.Element) => {
    if (!condition) {
        return <></>;
    }

    return typeof jsx === 'function' ? jsx() : jsx;
};
